module.exports = __webpack_public_path__ + "img/c.b8a918c1.png";